<template>
    <section class="tech-wrapper  pt-5 pb-5 mt-5">
        <div class="title mb-5 container">
            <h3>巧记账</h3>
            <h4 class="text-1e6ce8 ">QiaoJiZhang</h4>
        </div>
        <div class="bg-f8f6f9">
            <div class="container tech-main">
                <div class="row  p-5">
                    <div class="col-md-12 col-12  text-333"><p>全程无纸化、自动化、可视化，帮助中小微企业一键完成做账任务</p>
                        <!-- <p class="text-333 mb-2"><i class="iconfont  iconfangkuai text-1e6ce8"></i> 按月度结算客户的代理记账费用</p>
                        <p class="text-333 mb-2"><i class="iconfont  iconfangkuai text-1e6ce8"></i> 客户可随时充值任意金额，充值越多赠送也越多</p>
                        <p class="text-333 mb-2"><i class="iconfont  iconfangkuai text-1e6ce8"></i> 不满意随时退出，5个工作日内完成退出手续，试错成本低</p> -->
                    </div>
                    <!-- <div class="col-md-12 col-xs-12  mt-5 mb-5">
                        <img :src="flexibleImg" class="img-flexible-bottom" />
                    </div> -->
                    <div class="col-md-12 col-xs-12  mt-5 mb-5">
                        <div class="Flexible-content ">
                            <ul class=" text-fff text-right jiqiao">
                                <li class="font-16 font-blod"><strong>机巧智能代账公司</strong></li>
                                <li class="font-14">服务高效安全,标准化服务流程,更有多重安全保证<i class="iconfont iconduihao"></i></li>
                                <li class="font-14">财税风险预警,会计团队＋智能判别企业财税风险<i class="iconfont iconduihao"></i></li>
                                <li class="font-14">聘用会计专业能力存疑,无法适应企业需求<i class="iconfont iconduihao"></i></li>
                            </ul>
                            <ul class="text-fff text-left normal">
                                <li class="font-16 font-blod"><strong>传统代理记账公司</strong></li>
                                <li class="font-14">服务能力不一,聘用会计专业能力存疑,无法适应企业需求</li>
                                <li class="font-14">财税风险高人为处理易出错,错账漏报风险高</li>
                                <li class="font-14">账务管理不善,重要票据凭证管理不善,造成额外损失</li>
                            </ul>
                        </div>
                    </div>
                    <p class="text-center col-md-12 col-xs-12 ">
                        <a class="btn-custom" href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                            立即咨询
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
  name: 'Flexiblecharge',
  data () {
    return {
      flexibleImg: require('../../../assets/image/img-flexible-bottom.png')
    }
  },
  mounted () {
  }
}
</script>
<style>
.tech-main {
    position:relative
}
.tech-main::before {
    content: '';
    border-right: 2px solid #1e6ce8;
    height: 15px;
    margin-left: -17px;
    position: absolute;
    height: 236px;
    top: -113px;
}
.tech-main .img-flexible-bottom {
    width:100%;
}
.tech-main .Flexible-content {
    background: url('../../../assets/image/img-index-vs.png') 100% no-repeat;
    padding:60px 0;
    background-size:100%;
    display:flex
}
.tech-main .Flexible-content ul {
   flex:1;
   padding:25px 80px 0
}

.tech-main .Flexible-content ul li {
    position:relative;
    margin-bottom: 10px;
}
.tech-main .Flexible-content ul li:last-child {
    margin-bottom: 0px;
}
.tech-main .Flexible-content ul li .iconduihao {
   position:absolute;
   right:-25px;
   font-size:18px;
   top:0px
}
.btn-custom {
    padding: 10px 30px;
    background-image: linear-gradient(to right, #3ba7ff, #044fff);
    border-radius: 5px;
    color: #fff;
    text-decoration: none;
    margin: 0 auto;
    width:180px;
    text-align: center
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Flexiblecharge.vue